

module.exports = __webpack_require__.stylable.create(
    "DropdownLayout1965003724",
    {"classes":{"root":"DropdownLayout1965003724__root","contentContainer":"DropdownLayout1965003724__contentContainer","options":"DropdownLayout1965003724__options","option":"DropdownLayout1965003724__option","selectableOption":"DropdownLayout1965003724__selectableOption","arrow":"DropdownLayout1965003724__arrow","loader":"DropdownLayout1965003724__loader","linkItem":"DropdownLayout1965003724__linkItem"},"vars":{},"stVars":{"option_height":"36px","big_option_height":"47px","top-arrow-size":"8px","arrowUpShadow":"3px 3px 8px rgba(0, 0, 0, .1)","arrowDownShadow":"-3px -3px 8px rgba(0, 0, 0, .1)"},"keyframes":{}},
    "",
    7,
    "DropdownLayout1965003724",
    null
);
